export default __webpack_public_path__ + "static/DO_Logo_Rect-b677694ff5472809f7ef2dea7978d2c7.svg";